module.exports = __webpack_public_path__ + "static/media/400171_01.118769c3.png";